<template>
  <div
    class="absolute inset-0 flex-c px-6 md:px-10vw bg-cover bg-center"
    :style="`background-image: url(${image})`"
  >
    <Landing v-if="$route.params.category_id === 'home'"/>

    <div
      v-if="category.children.length"
      class="text-center"
    >
      <h1
        class="mb-2 md:mb-6"
        v-html="category.title"
      />
      <p
        v-if="category.slug !== 'subject-areas'"
        class="w-75vw md:w-45vw mx-auto mb-4 md:mb-8 font-graphiklight"
        v-html="category.description"
      />

      <RouterLink
        v-if="category.slug !== 'subject-areas'"
        :to="contentPath"
        append
        :aria-label="`Explore ${category.title}`"
        v-html="`Explore`"
        class="btn btn--black"
      />

      <SubjectMenu
        v-if="category.slug === 'subject-areas'"
        :subjects="subjects"
        :category="category"
      />
    </div>
    <More v-if="$route.params.category_id === 'find-out-more'" />
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import SubjectMenu from '@/components/SubjectMenu.vue'
import Landing from '@/components/Landing.vue'
import More from '@/components/More.vue'

export default {
  name: 'Category',

  components: {
    SubjectMenu,
    Landing,
    More

  },

  props: {
    category: {
      type: Object,
      default: () => {}
    }
  },

  computed: {
    ...mapState([ 'touch', 'mobile' ]),
    ...mapGetters([ 'subjects', 'categories' ]),

    contentPath() {
      return this.category.children.length > 0 ? this.category.children[0].slug : ''
    },

    image() {
      const imageLand = this.category.image ? this.category.image.srcLand : ''
      const imagePort = this.category.image ? this.category.image.srcPort : ''
      return this.mobile ? imagePort : imageLand
    }
  }
}
</script>
